var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBlur = function SvgBlur(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6800 6800",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#blur_svg__filter0_bf)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#blur_svg__paint0_radial)",
    d: "M1000 1000h4800v4800H1000z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4347FE",
    fillOpacity: 0.1,
    d: "M1000 1000h4800v4800H1000z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "blur_svg__paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 0 3400) scale(1816)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA2248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#4347FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#4347FE",
    stopOpacity: 0.489
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "#4347FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_svg__filter0_bf",
    x: 0,
    y: 0,
    width: 6800,
    height: 6800,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImage",
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 500,
    result: "effect2_foregroundBlur"
  })))));
};
export default SvgBlur;